// extracted by mini-css-extract-plugin
export default {"PasswordInput":"AccountAndPwdForm_PasswordInput__Lg9MZ","ForgotPwd":"AccountAndPwdForm_ForgotPwd__3CfFD"};